import styled from 'styled-components';
import { neutral } from '../../../style/colors';

export const TyreName = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${neutral[900]};
  margin: 0;
  line-height: 1.3;
`;

export const TyreDesign = styled.div`
  font-size: 12px;
  color: ${neutral[500]};
  font-weight: 500;
  line-height: 1.2;
  margin-top: 2px;
`;

export const Dimensions = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${neutral[700]};
  margin-bottom: 4px;
  line-height: 1.2;
`;

export const SpecsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 4px;
  align-items: baseline;
`;

export const SpecItem = styled.div`
  font-size: 11px;
  color: ${neutral[700]};
  display: flex;
  align-items: baseline;
  gap: 4px;

  strong {
    color: ${neutral[400]};
    font-weight: 500;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
`;

export const SpecValue = styled.span`
  font-weight: 500;
  color: ${neutral[900]};
`;

export const SeasonBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 500;
  color: ${neutral[500]};
  text-transform: capitalize;

  i {
    font-size: 14px;
    color: ${neutral[400]};
  }
`;
